<sat-popover
  #popRef
  [autoFocus]="false"
  [restoreFocus]="false"
  [verticalAlign]="'start'"
  [horizontalAlign]="'end'"
  hasBackdrop
  (backdropClicked)="popRef.close(); setActiveId.emit(undefined);">
  <mat-card class="__card  z-manual-elevation  c-soft-elevation">
    <mat-action-list class="__more-actions">

      <button
        *ngIf="revealKey && activeUserDataDelayed?.sensitive"
        mat-list-item
        (click)="(revealedContent[activeUserDataDelayed?.id] !== undefined ? hide.emit(activeUserDataDelayed?.id) : reveal.emit(activeUserDataDelayed?.id)); popRef.close(); setActiveId.emit(undefined);"
        type="button"
        [disabled]="loadingsMap[activeUserDataDelayed?.id]
          ? !!loadingsMap[activeUserDataDelayed?.id][revealKey]
          : false">
        <zui-progress-spinner
          hideContent
          [isLoading]="loadingsMap[activeUserDataDelayed?.id]
            ? !!loadingsMap[activeUserDataDelayed?.id][revealKey]
            : false">
          <zui-action-list-item
            [icon]="revealedContent[activeUserDataDelayed?.id] !== undefined ? 'visibility_off' : 'visibility'"
            [label]="revealedContent[activeUserDataDelayed?.id] !== undefined ? 'Hide value' : 'Reveal value'">
          </zui-action-list-item>
        </zui-progress-spinner>
      </button>

      <button
        mat-list-item
        #editDynamicAnchor="dynamicPopAnchor"
        [zuiDynamicPopAnchor]="editAnchor"
        (click)="edit.emit(); popRef.close(); (editAnchor ? editDynamicAnchor.open(false, activeElRef) : undefined)"
        [zefNgrxDialogOpen]="editAnchor ? editKey : undefined"
        type="button"
        [disabled]="loadingsMap[activeUserDataDelayed?.id]
          ? !!loadingsMap[activeUserDataDelayed?.id][editKey]
          : false">
        <zui-progress-spinner
          hideContent
          [isLoading]="loadingsMap[activeUserDataDelayed?.id]
            ? !!loadingsMap[activeUserDataDelayed?.id][editKey]
            : false">
            <zui-action-list-item
              [icon]="'edit'"
              [label]="'general.edit' | transloco">
            </zui-action-list-item>
        </zui-progress-spinner>
      </button>

      <div
        *ngIf="!activeUserDataDelayed?.deleteOnSync"
        [matTooltip]="editableVariableTranslation"
        [matTooltipClass]="'c-zerops-tooltip'"
        [matTooltipDisabled]="activeUserDataDelayed?.type !== userDataType.Editable">
        <button
          mat-list-item
          (click)="delete.emit(); popRef.close(); setActiveId.emit(undefined);"
          type="button"
          [disabled]="activeUserDataDelayed?.type === userDataType.Editable
            ? true
            : loadingsMap[activeUserDataDelayed?.id]
              ? !!loadingsMap[activeUserDataDelayed?.id][deleteKey]
              : false">
          <zui-progress-spinner
            hideContent
            [isLoading]="loadingsMap[activeUserDataDelayed?.id]
              ? !!loadingsMap[activeUserDataDelayed?.id][deleteKey]
              : false">
            <zui-action-list-item
              [icon]="activeUserDataDelayed?.type === userDataType.Editable
                ? 'lock'
                : loadingsMap[activeUserDataDelayed?.id] && !!loadingsMap[activeUserDataDelayed?.id][deleteKey]
                  ? 'lock'
                  : 'delete_outline'"
              [label]="'general.delete' | transloco">
            </zui-action-list-item>
          </zui-progress-spinner>
        </button>
      </div>

      <div
        *ngIf="activeUserDataDelayed?.deleteOnSync"
        [matTooltip]="editableVariableTranslation"
        [matTooltipDisabled]="activeUserDataDelayed?.type !== userDataType.Editable">
        <button
          mat-list-item
          (click)="restore.emit(); popRef.close(); setActiveId.emit(undefined)"
          type="button"
          [disabled]="activeUserDataDelayed?.type === userDataType.Editable
            ? true
            : loadingsMap[activeUserDataDelayed?.id]
              ? !!loadingsMap[activeUserDataDelayed?.id][restoreKey]
              : false">
          <zui-progress-spinner
            hideContent
            [isLoading]="loadingsMap[activeUserDataDelayed?.id]
              ? !!loadingsMap[activeUserDataDelayed?.id][restoreKey]
              : false">
            <zui-action-list-item
              [icon]="activeUserDataDelayed?.type === userDataType.Editable
                || (loadingsMap[activeUserDataDelayed?.id]
                  && !!loadingsMap[activeUserDataDelayed?.id][restoreKey])
                ? 'lock'
                : 'restore'"
              [label]="'general.restore' | transloco">
            </zui-action-list-item>
          </zui-progress-spinner>
        </button>
      </div>

    </mat-action-list>
  </mat-card>
</sat-popover>